import { render } from "./Fp_service.vue?vue&type=template&id=4de460be&scoped=true"
import script from "./Fp_service.vue?vue&type=script&lang=js"
export * from "./Fp_service.vue?vue&type=script&lang=js"

import "./Fp_service.vue?vue&type=style&index=0&id=4de460be&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de460be"]])

export default __exports__